import { render } from "./ImportStock.vue?vue&type=template&id=3a0b7728&scoped=true&ts=true"
import script from "./ImportStock.vue?vue&type=script&lang=ts"
export * from "./ImportStock.vue?vue&type=script&lang=ts"

import "./ImportStock.vue?vue&type=style&index=0&id=3a0b7728&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0b7728"]])

export default __exports__